export const NIT_COLSAISA = '900338016';


// WEBPACK FOOTER //
// ./src/util/subscribersConstanst.js